import { FaqComponent } from './../../../public/components/faq/faq';
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ChangeLogoModal } from 'src/modules/features/admin/modals';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { AccountService } from 'src/modules/features/setting/services';
import { AuthenticationService } from 'src/modules/core/services';
import {
  ConfirmModal,
  CommonServices,
  SharedValidators,
  TwoFactorModal,
  TwoFactorRecoveryModal,
} from 'src/modules/shared';
import { environment } from 'src/environments/environment';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { EwalletService } from 'src/modules/features/admin/services/ewallet';
import { Router } from '@angular/router';
@Component({
  selector: 'app-account-security',
  templateUrl: './account-security.component.html',
  styleUrls: ['./account-security.component.scss'],
})
export class AccountSecurityComponent implements OnInit {
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt;
  accountForm: FormGroup;
  user: any;
  organization: any;
  pending: boolean;
  error: any;
  success: any;
  image = 'assets/avatar/1.jpg';
  baseUrl: string = environment.API_SERVER;
  walletEnabled: boolean = false;
  FADetails;
  usedRecoveryCode: boolean = false;
  toggleChange: boolean = false;

  constructor(
    private commonSvc: CommonServices,
    private authService: AuthenticationService,
    private modalService: SuiModalService,
    private location: Location,
    private accountSvc: AccountService,
    private builder: FormBuilder,
    private walletService: EwalletService,
    private router: Router
  ) {
    this.organization = JSON.parse(window.localStorage.getItem('organization'));
    this.user = JSON.parse(window.localStorage.getItem('user'));
    this.getWalletDetails();
    this.get2FADetails();
    const recovery = window.localStorage.getItem('recoveryCodes');
    if (recovery === 'true') {
      this.usedRecoveryCode = true;
    }
    this.accountForm = this.builder.group(
      {
        oldPassword: ['', Validators.required],
        newPassword: [''],
        password: ['', [Validators.required, SharedValidators.strongPassword]],
        confirmPassword: [
          '',
          [Validators.required, SharedValidators.strongPassword],
        ],
      },
      {
        validator: SharedValidators.matchingPasswords(
          'password',
          'confirmPassword'
        ),
      }
    );

    this.authService.user.subscribe((res) => {
      this.user = res;
      if (this.user && this.user.image) {
        this.image = `${
          this.baseUrl
        }/public/image/?media=${this.user.image.replace(/\\/g, '/')}`;
      }
    });
  }

  isFieldValid(field: string) {
    return (
      (!this.accountForm.get(field).valid &&
        this.accountForm.get(field).touched) ||
      (this.accountForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }
  configureModal() {
    this.modalService
      .open(
        new TwoFactorModal(
          'Two-factor Authentication',
          'Are you sure you want to delete this app config?',
          false,
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.user['totpEnabled'] = true;
        window.localStorage.setItem('user', JSON.stringify(this.user));
        localStorage.removeItem('recoveryCodes');
        this.success = '2FA setup completed';
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      })
      .onDeny(() => {
        // this.disabled2FA();
      });
  }
  toggle(event) {
    if (event == true) {
      this.modalService
        .open(
          new TwoFactorModal(
            'Two-factor Authentication',
            'Are you sure you want to delete this app config?',
            false,
            ModalSize.Tiny
          )
        )
        .onApprove(() => {
          this.user['totpEnabled'] = true;
          window.localStorage.setItem('user', JSON.stringify(this.user));
          localStorage.removeItem('recoveryCodes');
          this.success = '2FA setup completed';
          this.toggleChange = true;
          setTimeout(() => {
            window.location.reload();
          }, 2000);

          // this.get2FADetails();
        })
        .onDeny(() => {
          this.user['totpEnabled'] = false;
        });
    } else {
      this.disabled2FA();
    }
  }
  getRecoveryCode() {
    this.modalService
      .open(
        new TwoFactorRecoveryModal(
          'Authentication Verification',
          'Are you sure you want to delete this app config?',
          false,
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        localStorage.removeItem('recoveryCodes');
        window.location.reload();
      })
      .onDeny(() => {});
  }
  disabled2FA() {
    this.walletEnabled
      ? this.modalService
          .open(
            new ConfirmModal(
              'Disable Two-factor Authentication?',
              'You cannot disable your Two-Factor Authentication (2FA) because you have an active eWallet Account',
              ModalSize.Tiny,
              'Okay',
              ''
            )
          )
          .onApprove(() => {
            this.user['totpEnabled'] = true;
            this.error =
              'You cannot disable your Two-Factor Authentication (2FA) because you have an active eWallet Account';
          })
          .onDeny(() => {
            this.user['totpEnabled'] = true;
            this.error =
              'You cannot disable your Two-Factor Authentication (2FA) because you have an active eWallet Account';
          })
      : this.modalService
          .open(
            new ConfirmModal(
              'Disable Two-factor Authentication?',
              'Are you sure you want to disable two-factor authentication?',
              ModalSize.Tiny
            )
          )
          .onApprove(() => {
            this.pending = true;
            this.commonSvc.disableTwoFactor().subscribe(
              (res) => {
                this.pending = false;
                this.success = '2-factor authentication disabled successfully';
                this.user['totpEnabled'] = false;
                window.localStorage.setItem('user', JSON.stringify(this.user));
              },
              (error) => {
                this.pending = false;
                this.error = error.error.errorMessage
                  ? error.error.errorMessage
                  : error.error
                  ? error.error
                  : error;
              }
            );
          })
          .onDeny(() => {
            this.user['totpEnabled'] = true;
          });
  }
  getWalletDetails() {
    this.pending = true;
    this.error = null;
    this.walletService
      .getWalletDetails({
        nccId: this.organization.jpaContractor.nccId,
      })
      .subscribe(
        (res: any) => {
          this.walletEnabled =
            res.ewalletActivated && res.ewalletActivationDate;
          this.pending = false;
          this.toggleChange = this.user.totpEnabled;
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  get2FADetails() {
    this.pending = true;
    this.error = null;
    this.walletService
      .get2FADetails({
        appUserId: this.user.appUserId,
      })
      .subscribe(
        (res: any) => {
          this.FADetails = res;
          this.pending = false;
        },
        (error) => {
          this.pending = false;
        }
      );
  }
  submit() {
    this.pending = true;
    this.error = null;
    this.success = null;
    this.formSubmitAttempt = true;
    let payload = {
      oldPassword: this.accountForm.value.oldPassword,
      newPassword: this.accountForm.value.password,
    };
    if (this.accountForm.valid) {
      this.accountSvc
        .changePassword({ appUserId: this.user.appUserId, body: payload })
        .subscribe(
          (res) => {
            this.pending = false;
            this.success = 'Password changed successfully';
          },
          (error) => {
            this.pending = false;
            this.error = error.error.errorMessage
              ? error.error.errorMessage
              : error.error
              ? error.error
              : error;
            if (error.error['statusCode'] == 500) {
              this.error = 'Incorrect current password';
            }
          }
        );
    } else {
      this.formSubmitAttempt = true;
      this.pending = false;
      this.error = 'Please fill all required fields';
    }
  }

  goBack() {
    this.location.back();
  }
  ngOnInit(): void {}
  editUsername() {}
  editEmail() {}
}
